<template>
  <div class="fullscreen">
    <div v-if="isFullScreen" class="fullscreen__button" @click="minimize" tabindex="0">
      <sh-icon class="fullscreen__expand" name="fullScreenOff" :size="iconSize"/>
    </div>
    <div v-else class="fullscreen__button" @click="expand">
      <sh-icon class="fullscreen__volume" name="fullScreen" :size="iconSize" tabindex="0"/>
    </div>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'

export default {
  name: 'VimeoFullScreen',
  components: {
    ShIcon
  },
  props: {
    isFullScreen: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    iconSize () {
      return this.$device.isMobile ? 'small' : 'medium'
    }
  },
  methods: {
    minimize () {
      this.$emit('minimize')
    },
    expand () {
      this.$emit('expand')
    }
  }
}
</script>

<style lang="scss" scoped>
.fullscreen {
  padding: 0 $space-040;
  cursor: pointer;

  @include tablet {
    padding: 0 $space-040 0 $space-060;
  }
}
</style>
